<template>
    <div>
        <button-fragment
            :disabled=disabled
            :size=size
        >
            <label>
                <input
                    type="file"
                    style="display: none;"
                    @change="handleUpload($event)"
                />
                {{label}}
            </label>
        </button-fragment>
        <div>
            <slot name="result"></slot>
        </div>
    </div>
</template>

<script>
import ButtonFragment from "./button-fragment";

export default {
    name: 'upload-fragment',
    components: {
        ButtonFragment
    },
    props: {
        label: {type: String, required: true},
        value: {type: String},
        disabled: {type: Boolean, default: false},
        isInvalid: {type: Boolean, default: false},
        fileSizeMax: {type: Number, required: true},
        supportedMimeTypes: {type: Array, required: true},
        size: {
            type: String,
            default: "medium",
            validator: function(value) {
                return ["small", "medium", "max"].indexOf(value) !== -1;
            }
        }
    },
    methods: {
        handleUpload($event) {
            const file = $event.target.files[0];

            if (file) {
                if (file.type === "" || file.type == null || this.supportedMimeTypes.indexOf(file.type) < 0) {
                    this.$emit("file-invalid", "type");
                    return;
                }

                if (this.fileSizeMax < file.size) {
                    this.$emit("file-invalid", "size");
                    return;
                }

                this.$emit("file-valid");
                this.$emit("input", file);
            } else {
                this.$emit("file-invalid", "missing");
            }
        }
    }
}
</script>